module.exports = __webpack_public_path__ + "static/img1-b7919e5761efcf1c6439fcb85ecda259.png";